import { useContext } from 'react';

import { StackIndexContext } from '../components/stack-index-context/StackIndexContext';

export const useHistoryStackIndex = () => {
  return useContext(StackIndexContext);
};
